export const TYPE = 'TYPE';
export const CURRICULUM = 'CURRICULUM';
export const SUBJECT = 'SUBJECT';
export const SUBTOPIC = 'SUBTOPIC';



// WEBPACK FOOTER //
// ./app/constants/gtmGroups.js